package com.gsb.vyapar.bhagya.presentation.location.uistate

import com.gsb.vyapar.bhagya.datasource.preference.Preference
import com.gsb.vyapar.bhagya.domain.Location
import com.gsb.vyapar.bhagya.domain.decodeLocationString
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.getState
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.updateState

data class LocationUiState(
    val pincode: String = Preference.pincode,
    val location: Location? = Preference.location.decodeLocationString(),
) {
    fun updatePincode(pincode: String) {
        updateLocationUiState(this.copy(pincode = pincode))
    }

    fun updateLocation(location: Location?) {
        updateLocationUiState(this.copy(location = location))
    }
}

fun updateLocationUiState(locationUiState: LocationUiState) {
    updateState(getState().copy(locationUiState = locationUiState))
}

fun getLocationUiState(): LocationUiState {
    return getState().locationUiState
}
